import { filter, map } from "rxjs/operators";
import { actionBaseInfoRemoveBuilding } from "../../../info/base/actionBaseInfo";
import { TypeActionBuildings } from "../actionBuildings";
export var epicBuildingsStartMove = function (action$) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionBuildings.StartMove ||
            action.type === TypeActionBuildings.Rotate;
    }), map(function (action) { return actionBaseInfoRemoveBuilding(action.building.proto); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsStartMove.ts
// module id = 2086
// module chunks = 3